import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { API_URL } from '@core/config/api-url.token';
import { API_ENDPOINTS } from '@shared/constants/api-endpoints.const';
import { Observable } from 'rxjs';
import { ClientReceivedDocumentDto } from '../../dtos/client-received-document.dto';

@Injectable()
export class ClientDocumentsRemoteDatasource {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = inject(API_URL);

  // `GET /api/organizations/{organizationId}/clients/{recipientClientId}/documents` --
  // `[Authorize(Policy="RequireStaff")]`, `recipientClientId` is a GUID (`AppClient.Id`). See
  // `ChatController.GetClientReceivedDocuments`.
  public list(organizationId: number, recipientClientId: string): Observable<readonly ClientReceivedDocumentDto[]> {
    return this.http.get<readonly ClientReceivedDocumentDto[]>(
      `${this.apiUrl}${API_ENDPOINTS.documents.forClient(organizationId, recipientClientId)}`,
    );
  }

  // `POST /api/organizations/{organizationId}/clients/{recipientAppClientId}/documents` --
  // `recipientAppClientId` is the `AppClient.Id` (a GUID), same as `list`. See
  // `DocumentsController.UploadClientDocument`; mirrors `PatientDocumentsRemoteDatasource.upload`.
  public upload(
    organizationId: number,
    recipientAppClientId: string,
    file: File,
  ): Observable<ClientReceivedDocumentDto> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<ClientReceivedDocumentDto>(
      `${this.apiUrl}${API_ENDPOINTS.documents.forClient(organizationId, recipientAppClientId)}`,
      formData,
    );
  }

  // Same generic document-delete endpoint used by `PatientDocumentsRemoteDatasource.remove` --
  // `Document` deletion is keyed only by `Id` + `organizationId`, regardless of whether the document
  // originated from a chat attachment or a patient upload.
  public remove(organizationId: number, documentId: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}${API_ENDPOINTS.documents.byId(organizationId, documentId)}`);
  }
}
